import React from 'react';

function Welcome() {
  return (<p>No application is currently selected.</p>);
}

export default Welcome;
